module.exports = __webpack_public_path__ + "img/2.7.Chla.46b388cd.png";